import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import { store } from '../store';

// eslint-disable-next-line import/prefer-default-export
export function validateClient() {
  return axios({
    url: '/version.json',
    params: { cb: Date.now() }, // Cache-buster.
  }).then((res) => {
    if (res.status === 200) {
      const currentVersion = store.getState().session.version;

      if (res.data.version !== currentVersion) {
        // A new version was found so show the stale client toast.
        store.dispatch({ type: 'UPDATE_VERSION', version: res.data.version });
        store.dispatch({ type: 'SET_MODAL', payload: { staleClientModal: true } });
      }
    } else {
      // eslint-disable-next-line no-console
      console.error(`[Client Validation ERR] ${res.status}: ${res.statusText}`);
    }
  });
}
